import React, { Component } from 'react';
import { Form, Checkbox } from 'components/antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { getOptionalLabel } from 'components/antd/Modal/TitleNotice';

interface Props {
	form: WrappedFormUtils;
	bookingConfirmationName: string;
	bookingConfirmationData: boolean;
	invoiceConfirmationName: string;
	invoiceConfirmationData: boolean;
	calendarBookingEventName: string;
	calendarBookingEventData: boolean;
}

export default class NotificationByEmail extends Component<Props> {
	render() {
		const {
			form,
			bookingConfirmationName,
			bookingConfirmationData,
			invoiceConfirmationName,
			invoiceConfirmationData,
			calendarBookingEventName,
			calendarBookingEventData,
		} = this.props;
		const { getFieldDecorator } = form;

		return (
			<Form.Item
				label={getOptionalLabel('Notifications by email', 'Upcoming feature')}
				validateStatus={''}
				help={''}
			>
				{getFieldDecorator(bookingConfirmationName, {
					initialValue: bookingConfirmationData,
					valuePropName: 'checked',
				})(<Checkbox disabled>Booking confirmation</Checkbox>)}
				{getFieldDecorator(invoiceConfirmationName, {
					initialValue: invoiceConfirmationData,
					valuePropName: 'checked',
				})(<Checkbox disabled>Invoice confirmation</Checkbox>)}
				{getFieldDecorator(calendarBookingEventName, {
					initialValue: calendarBookingEventData,
					valuePropName: 'checked',
				})(<Checkbox disabled>Calendar booking event</Checkbox>)}
			</Form.Item>
		);
	}
}
